/**
 * Returns true when the app is running on macOS, so hotkey display can show Command instead of Ctrl.
 */
export function isMacOs(): boolean {
  if (typeof navigator === 'undefined') return false;
  const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
  if (nav.userAgentData?.platform === 'macOS') return true;
  const platform = navigator.platform ?? '';
  return String(platform).toLowerCase().includes('mac');
}
